import { render, staticRenderFns } from "./DepositReceipt.vue?vue&type=template&id=77adc4f1&"
import script from "./DepositReceipt.vue?vue&type=script&lang=js&"
export * from "./DepositReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports